/** CSV Innovorder partagé. Lecture locale uniquement, aucune preuve de consentement marketing. */
const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i;
function cells(text, separator) {
  const rows = [];
  let row = [],
    cell = "",
    quoted = false;
  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (c === '"') {
      if (quoted && text[i + 1] === '"') {
        cell += '"';
        i++;
      } else quoted = !quoted;
    } else if (c === separator && !quoted) {
      row.push(cell);
      cell = "";
    } else if ((c === "\n" || c === "\r") && !quoted) {
      if (c === "\r" && text[i + 1] === "\n") i++;
      row.push(cell);
      if (row.some((v) => v.trim())) rows.push(row);
      row = [];
      cell = "";
    } else cell += c;
  }
  if (quoted) throw new Error("INVALID_CSV");
  row.push(cell);
  if (row.some((v) => v.trim())) rows.push(row);
  return rows;
}
function parseCsv(input) {
  const text = String(input).replace(/^\uFEFF/, "");
  if (text.length > 1000000) throw new Error("CSV_TOO_LARGE");
  const first = text.split(/\r?\n/, 1)[0] || "";
  const separator =
    cells(first, ";")[0]?.length >= cells(first, ",")[0]?.length ? ";" : ",";
  const rows = cells(text, separator);
  if (!rows.length) return [];
  const header = rows.shift().map((v) => v.trim().toLowerCase()),
    emailIdx = header.findIndex(
      (h) => h === "email" || h.includes("mail") || h.includes("e-mail"),
    ),
    firstIdx = header.findIndex(
      (h) =>
        h.includes("prénom") || h.includes("prenom") || h.includes("first"),
    ),
    lastIdx = header.findIndex(
      (h) =>
        (h === "nom" || h.includes("last") || h.includes("name")) &&
        !h.includes("prénom") &&
        !h.includes("prenom") &&
        !h.includes("first"),
    );
  const result = [],
    seen = new Set();
  for (const values of rows) {
    let email = (values[emailIdx] || "").trim().toLowerCase();
    if (!EMAIL_RE.test(email))
      email = (values.find((v) => EMAIL_RE.test(v.trim())) || "")
        .trim()
        .toLowerCase();
    if (!email || seen.has(email)) continue;
    seen.add(email);
    const name = [
      firstIdx >= 0 ? values[firstIdx] : "",
      lastIdx >= 0 ? values[lastIdx] : "",
    ]
      .map((v) => (v || "").trim())
      .filter(Boolean)
      .join(" ");
    result.push({ email, name });
    if (result.length > 5000) throw new Error("CSV_TOO_MANY_CONTACTS");
  }
  return result;
}
module.exports = { parseCsv };
